module.exports = __webpack_public_path__ + "static/media/espiga_escudoplus.f926f412.png";